<template>
  <div class="">
    <div class="modal">
      <div class="close">
        <button @click="modalClose" class="close_btn"><img :src="require('@/assets/images/common/close.svg')" alt=""></button>
      </div>

      <div class="modal_text_wrap">
        <p class="modal_text ar">開始日</p>
        <p class="modal_text ar">終了日</p>
      </div>
      <div class="modal_search">
        <div class="date_wrap">
          <input class="input_date rb" type="date" name="" :value="from " @input="inputFrom">
        </div>
        <span class="rm">~</span>
        <div class="date_wrap">
          <input class="input_date rb" type="date" :value="to" name="" @input="inputTo">
        </div>
      </div>
      <p v-if="errorMessage != ''" class="error_message c5a ab mt16" v-html="errorMessage">{{ errorMessage }}</p>
      <button @click="checkModal" class="btn_blue btn_modal_search" type="button" name="button">検索</button>

    </div>
    <div class="modal_bg"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      errorMessage: '',
      from: '',
      to: ''
    }
  },
  methods: {
    checkModal() {

      let isError = false;
      this.errorMessage = '';
      if(this.from == null || this.from == '') {
        this.from = this.fromDate;
        if(this.fromDate == null || this.fromDate == '') {
          isError = true;
          this.errorMessage += '開始日を入力してください<br>';
        }
        // isError = true;
      }
      if(this.to == null || this.to == '') {
        this.to = this.toDate;
        if(this.toDate == null || this.toDate == '')
        isError = true;
        this.errorMessage += '終了日を入力してください<br>';
      }
      if(isError) return true;
      this.$store.commit('setCashFlowFromDate', this.from);
      this.$store.commit('setCashFlowToDate', this.to);
      this.$emit('setDate');
      this.modalClose();
    },
    modalClose() {
      this.$store.commit('setCashFlowModal', false);
    },
    inputFrom(e) {
      this.from = e.target.value;

    },
    inputTo(e) {
      this.to = e.target.value;

    },
  },
  computed: mapGetters(['fromDate', 'toDate']),
  created() {
    this.from = this.fromDate;
    this.to = this.toDate;
  },
}
</script>

<style lang="css" scoped>
.error_message {
  color: red;
  font-size: 14px;
}
.modal {
  background-color: #fff;
  border-radius: 0px 0px 12px 12px;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  /* display: none; */
  left: 0;
  padding: 21px 16px 21.3%;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
}
/* .modal.open {
  display: block;
} */
.modal_bg {
  background: rgba(14, 14, 14, 0.5);
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 0;
}

.close {
  display: flex;
  justify-content: flex-end;
}
.close .close_btn {
  background-color: transparent;
  border: none;
  padding: 0;
}

.modal_text_wrap {
  display: flex;
  justify-content: space-between;
  margin-top: 16.6%;
}
.modal_text_wrap .modal_text {
  color: #878787;
  font-size: 12px;
  width: calc(50% - 10.5px);
}
.modal_search {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}
.date_wrap {
  width: 47%;
}
.input_date {
  box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  border: none;
  font-size: 16px;
  padding: 9px 12px;
  width: 100%;
}

.btn_modal_search {
  margin-top: 18.6%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/wallet/CashFlowModal.vue